import { AttributesMixin, define } from "@type-r/models";
import { CountsModel } from "./countsModel";
import { restfulIO } from "./endpoint";

export interface PaymentCount extends AttributesMixin<typeof PaymentCount> { }

@define
export class PaymentCount extends CountsModel {
    static endpoint = restfulIO('api/v1/ingest/payments/counts');

    static attributes = {
        ...CountsModel.attributes
    };

}
